const KEYS_CACHE: { [name: string]: string[] } = {};
const SPLIT_REGEX = /[[\].]/;

export const getPath = (str: string) => {
  if (!KEYS_CACHE[str]) KEYS_CACHE[str] = str.split(SPLIT_REGEX).filter(Boolean);

  return KEYS_CACHE[str];
};
